import { render, staticRenderFns } from "./EducationTable.vue?vue&type=template&id=6b28f6b0"
import script from "./EducationTable.vue?vue&type=script&lang=js"
export * from "./EducationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports